module.exports = __webpack_public_path__ + "media/images/public_logo-8d29ab2f1d17dcfd545f541e1f3d612c.svg";